import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=6547b8a8&"
import script from "./DeviceDetail.vue?vue&type=script&lang=ts&"
export * from "./DeviceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports